import {AfterViewInit, Component, Input, OnInit, ViewChildren} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TemplateService} from '../../shared/template.service';
import {Template} from '../../shared/template';
import {Router} from "@angular/router";

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss'],
  providers: [TemplateService]
})
export class CreateTemplateComponent implements OnInit, AfterViewInit {

  template: Template = new Template(null, '', '', '', null);
  @ViewChildren('input') vc;

  constructor(public activeModal: NgbActiveModal, private templateService: TemplateService, private router: Router) {}

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.vc.first.nativeElement.focus();
  }

  create() {

      this.templateService.create(this.template).then(template => {
          this.activeModal.close('Close click');
          this.router.navigate(['/template', template.id]);
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/template/template-list/create-template/create-template.component.ts